<template>
    <div :class="contentClass" style="text-align: justify" v-html="layout.content"></div>
</template>

<script>
export default {
    props: ['layout', 'contentClass'],
};
</script>
